<template>
  <div class="app-container">
    <div>
    <el-button
      size="small"
      type="primary"
      class="go-back"
      @click.stop="goBack()"
    >
      返回
    </el-button><span style="font-size: 18px;margin-left: 10px;margin-top: 8px"  >当前圈子：{{this.ForumGroupName}}</span></div>
    <el-card class="box-card">
      <!-- 顶部栏搜索 -->
      <div class="topbar">
        <div>
          <el-input
            v-model="searchValue"
            size="small"
            placeholder="姓 / 名 / 昵称"
            prefix-icon="el-icon-search"
            class="search-input"
          />
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            :disabled="!searchValue"
            @click.stop="search()"
          >
            搜索
          </el-button>
          <el-button
            type="info"
            icon="el-icon-refresh"
            size="small"
            @click.stop="reset()"
          >
            重置
          </el-button>
        </div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-document"
            size="small"
            @click.stop="openTheBlackListDialog()"
          >
            黑名单({{blackList.length}})
          </el-button>
          <!-- <el-button
            type="primary"
            icon="el-icon-setting"
            size="small"
            @click.stop="openTheAdministratorSettingDialog()"
          >
            设置管理员
          </el-button> -->
        </div>
      </div>
      <!-- 表内容 -->
      <el-table
        :data="groupMemberList"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px"
      >
        <el-table-column prop="userId" label="用户ID" align="center" />
        <el-table-column
                label="头像"
                align="center"
        >
          <template #default="props">
            <el-avatar :key="props.row.avatar" :src="getImageUrl(props.row.avatar)"></el-avatar>
          </template>
        </el-table-column>
        <el-table-column
          prop="userNickname"
          label="昵称"
          align="center"
          show-overflow-tooltip
        />
        <el-table-column prop="memberRole" label="是否专家" align="center">
          <template slot-scope="scope">
            {{ scope.row.isUltraExpert === false ? '否' : '是' }}
          </template>
        </el-table-column>
        <el-table-column prop="memberRole" label="角色" align="center">
          <template slot-scope="scope">
            <a style="color: darkgreen">{{
              scope.row.memberRole === 0
                ? '普通成员'
                : scope.row.memberRole === 1
                ? '管理员'
                : '创建者'
              }}</a>
          </template>
        </el-table-column>
        <el-table-column label="加入时间" align="center"  width="160">
          <template slot-scope="scope">
            {{ scope.row.joinTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="350">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="primary"
              @click.stop="openEditMemberRoleDialog(scope.row)"
            >
              修改角色
            </el-button>
            <el-button
              size="small"
              :type="scope.row.forbidPublish!==0 ? 'warning' : 'success'"
              @click.stop="openForbidMemberDialog(scope.row)"
            >
              {{ scope.row.forbidPublish===0 ? '禁言' : '解禁' }}
            </el-button>
            <el-button
              size="small"
              type="info"
              @click.stop="blockMember(scope.row)"
            >
              拉黑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click.stop="deleteMember(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        v-show="totalCount > pageSize"
        background
        layout="prev, pager, next"
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
      />
    </el-card>

    <el-dialog title="黑名单" width="40%" :visible.sync="dialogTableVisible">
      <el-table :data="blackList">
        <el-table-column
          align="center"
          property="blackUserId"
          label="用户ID"
          width="90"
        />
        <el-table-column
          align="center"
          property="nickname"
          label="昵称"
          show-overflow-tooltip
        />
        <el-table-column align="center" label="姓名" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.firstName + scope.row.lastName }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              @click="unBlockMember(scope.row)"
            >
              移出
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="角色设置"
      :visible.sync="editMemberRoleDialog"
      width="20%"
    >
      <el-form :model="editMemberRoleForm">
        <el-form-item label="用户角色" label-width="80px">
          <el-select
            v-model="editMemberRoleForm.memberRole"
            style="width: 100%"
          >
            <el-option label="普通用户" :value="0" />
            <el-option label="管理员" :value="1" />
            <el-option label="创建者" :value="2" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editMemberRoleDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="editMemberRole()">
          确 定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="管理员列表"
      width="20%"
      :visible.sync="dialogTableVisible2"
    >
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click.stop="openTheAddAdministratorDialog()"
      >
        添加管理员
      </el-button>
      <el-table :data="blackList">
        <el-table-column align="center" property="date" label="日期" />
        <el-table-column align="center" property="name" label="姓名" />
        <el-table-column
          align="center"
          property="address"
          label="地址"
          width="100"
        >
          <el-button type="danger" size="small" @click="onSubmit">
            移除
          </el-button>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="添加管理员"
      width="20%"
      :visible.sync="dialogTableVisible3"
    >
      <el-table :data="blackList">
        <el-table-column align="center" property="BlackUserID" label="日期" />
        <el-table-column align="center" property="Nickname" label="姓名" />
        <el-table-column
          align="center"
          property="address"
          label="地址"
          width="100"
        >
          <el-button type="success" size="small" @click="onSubmit">
            添加
          </el-button>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
            title="禁言/解禁群成员"
            :visible.sync="forbidUserDialog"
            width="30%"
    >
      <el-form :model="ForumMemberForbiddenParam">
        <el-form-item label="禁言方式" label-width="80px" required>
          <el-select
                  v-model="ForumMemberForbiddenParam.forbidType"
                  style="width: 100%"
          >
            <el-option label="允许发言" :value="0"> </el-option>
            <el-option label="指定时间内禁言" :value="2"> </el-option>
            <el-option label="永久禁言" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解禁时间" label-width="80px" required v-if="ForumMemberForbiddenParam.forbidType===2">
            <el-date-picker type="date" placeholder="日期" v-model="ForumMemberForbiddenParam.endTime1" style="width:100%;"></el-date-picker>
         </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="forbidUserDialog = false">
          取消
        </el-button>
        <el-button
                type="primary"
                size="small"
                @click="forbiddenMember()"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGroupMemberList,
  setMemberRole,
  forbiddenMember,
  blockMember,
  getBlackUserList,
  deleteMember
} from '@/api/ultrasonicGroupsMember'
import {
  getCloudUrl
} from "@/utils/urlutil"
import {isVaild} from "@/utils/validate";
export default {
  data() {
    return {
      ForumGroupName:'',
      ForumMemberForbiddenParam:{
        endTime1:'',
        forbidType:'',
        forumGroupId:'',
        userId:''
      },
      forbidUserDialog:false,
      ForumGroupID: '',
      loading: false, // 加载开关
      searchValue: '', // 搜索内容
      searchBlackListValue: '', // 搜索黑名单列表内容
      searchAdminListValue: '', // 搜索管理员列表内容
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      groupMemberList: [],
      totalCount2: 0, // 列表总数
      pageSize2: 10, // 单页条数
      currentPage2: 1, // 当前页码
      blackList: [],
      adminList: [],
      editMemberRoleDialog: false,
      editMemberRoleForm: {},
      part:null,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      dialogTableVisible3: false
    }
  },
  created() {
    this.ForumGroupID = this.$route.query.ForumGroupID
    this.ForumGroupName=this.$route.query.groupName
    this.part=this.$route.query.part
    this.getGroupMemberList();
    this.getBlackUserList()
  },
  methods: {
    getImageUrl(path) {
      return getCloudUrl(path);
    },
    /**
     * 回到上一级：带参数
     */
    goBack() {
      let params={
        part: this.part,
        currentPage:this.$route.query.currentPage
      }
      if(isVaild(this.$route.query.groupType)){
        params.groupType=this.$route.query.groupType
      }
      if(isVaild(this.$route.query.userDataType)){
        params.groupType=this.$route.query.userDataType
      }
      if(isVaild(this.$route.query.searchValue)){
        params.groupType=this.$route.query.searchValue
      }
      this.$router.replace({
        name: "forum_page",
        params: params
      })
    },
    /**
     * 搜索
     */
    search() {
      this.currentPage = 1;
      console.log("hahah")
      this.getGroupMemberList();
    },
    /**
     * 重置
     */
    reset() {
      this.searchValue = ''
      this.getGroupMemberList()
    },
    /**
     * 翻页
     *
     * @param {number} currentPage 当前页码
     */
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.getGroupMemberList()
    },
    /**
     *
     */
    getGroupMemberList() {
      this.loading = true;
      const params = {
        forumGroupId: this.ForumGroupID,
        sortName: '',
        sortOrder: '',
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.searchValue,
        where: ''
      }
      getGroupMemberList(params).then(res => {
        this.groupMemberList = res.data.rows
        this.totalCount = res.data.total
        this.utils.stopLoading(this)
      })
    },
    /**
     *
     */
    openEditMemberRoleDialog(row) {
      this.$set(this.editMemberRoleForm, 'userId', row.userId)
      this.$set(this.editMemberRoleForm, 'memberRole', row.memberRole)
      this.editMemberRoleDialog = true
    },
    /**
     *
     */
    editMemberRole() {
      this.editMemberRoleDialog = false
      const data = {
        forumGroupId: this.ForumGroupID,
        userId: this.editMemberRoleForm.userId,
        role: this.editMemberRoleForm.memberRole
      }
      setMemberRole(data).then(() => {
        this.$message({
          message: '修改成功!',
          type: 'success'
        })
        this.getGroupMemberList()
      })
    },
    /**
     * 禁言组内用户
     *
     * @param {object} row 所选对象信息
     */
    openForbidMemberDialog(row){
      this.forbidUserDialog=true;
      this.ForumMemberForbiddenParam={
          endTime1:'',
          forbidType:row.forbidPublish===0?2:0,
          forumGroupId:this.ForumGroupID,
          userId:row.userId
      };
    },

    forbiddenMember(row) {
      if (this.ForumMemberForbiddenParam.forbidType===null) {
        this.$notify({
          title: '温馨提示',
          message: '禁言类型不能为空',
          type: 'warning'
        });
        return;
      }
      if (this.ForumMemberForbiddenParam.forbidType===2&&(this.ForumMemberForbiddenParam.endTime1==='')){
        {
          this.$notify({
            title: '温馨提示',
            message: '解禁时间不能为空',
            type: 'warning'
          });
          return;
        }
      }
      if(this.ForumMemberForbiddenParam.forbidType!==2){
        this.ForumMemberForbiddenParam.endTime1='';
        this.ForumMemberForbiddenParam.endTime2='';
      }
      const params = {
        forumGroupId: this.ForumMemberForbiddenParam.forumGroupId,
        userId: this.ForumMemberForbiddenParam.userId,
        forbidType: this.ForumMemberForbiddenParam.forbidType
      }
      if(this.ForumMemberForbiddenParam.forbidType===2){
        params.endTime=this.formateDateTime1(this.ForumMemberForbiddenParam.endTime1);
      }
      forbiddenMember(params).then(res => {
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
        this.getGroupMemberList();
        this.forbidUserDialog=false;
      })

    },

    formateDateTime1(value){
      if (!value) return ""

      const date = new Date(value)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let seconds = date.getSeconds()

      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (seconds < 10) {
        seconds = '0' + seconds
      }

      return (
          year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
      )
    },
    /**
     * 拉黑组内用户
     *
     * @param {object} row 所选对象信息
     */
    blockMember(row) {
      const params = {
        forumGroupId: this.ForumGroupID,
        userId: row.userId,
        status: 1
      }
      this.$confirm('是否拉黑该用户', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          blockMember(params).then(() => {
            this.$message({
              type: 'success',
              message: '拉黑成功!'
            })
            this.getGroupMemberList()
            this.getBlackUserList()
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    },
    /**
     * 打开黑名单用户列表对话框
     */
    openTheBlackListDialog() {
      this.dialogTableVisible = true
    },
    /**
     * 获取黑名单用户列表
     */
    getBlackUserList() {
      const params = {
        forumGroupId: this.ForumGroupID,
        pageNumber: this.currentPage2,
        pageSize: this.pageSize2,
      };
      getBlackUserList(params).then(res => {
        this.blackList = res.data.rows;
        this.totalCount2 = res.total;
      })
    },
    /**
     * 移除组内黑名单用户
     *
     * @param {object} row 所选对象信息
     */
    unBlockMember(row) {
      const params = {
        forumGroupId: this.ForumGroupID,
        userId: row.blackUserId,
        status: 0
      }
      this.$confirm('是否从群组黑名单中移除该用户', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          blockMember(params).then(() => {
            this.$message({
              type: 'success',
              message: '移除成功!'
            })
            this.getBlackUserList()
          })
        })
        .catch(() => {
        })
    },
    /**
     * 删除组内成员用户
     *
     * @param {object} row 所选对象信息
     */
    deleteMember(row) {
      const params = {
        forumGroupId: this.ForumGroupID,
        userId: row.userId
      };
      this.$confirm('是否删除该用户', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          deleteMember(params).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getGroupMemberList()
          })
        })
        .catch(() => {
          this.$message('取消操作')
        })
    },
    /**
     *
     */
    openTheAdministratorSettingDialog() {
      this.dialogTableVisible2 = true
    },
    /**
     *
     */
    openTheAddAdministratorDialog() {
      this.dialogTableVisible3 = true
    },
    onSubmit() {}
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
